import { Mode as Mode$1 } from '../common/Mode.js';

/**
 * @module QRData
 * @author nuintun
 * @author Kazuhiko Arase
 */
var QRData = /*#__PURE__*/ (function () {
    function QRData(mode, data) {
        this.mode = mode;
        this.data = data;
    }
    QRData.prototype.getMode = function () {
        return this.mode;
    };
    QRData.prototype.getLengthInBits = function (version) {
        var mode = this.mode;
        var error = new Error("illegal mode: " + mode);
        if (1 <= version && version < 10) {
            // 1 - 9
            switch (mode) {
                case Mode$1.Numeric:
                    return 10;
                case Mode$1.Alphanumeric:
                    return 9;
                case Mode$1.Byte:
                    return 8;
                case Mode$1.Kanji:
                    return 8;
                default:
                    throw error;
            }
        }
        else if (version < 27) {
            // 10 - 26
            switch (mode) {
                case Mode$1.Numeric:
                    return 12;
                case Mode$1.Alphanumeric:
                    return 11;
                case Mode$1.Byte:
                    return 16;
                case Mode$1.Kanji:
                    return 10;
                default:
                    throw error;
            }
        }
        else if (version < 41) {
            // 27 - 40
            switch (mode) {
                case Mode$1.Numeric:
                    return 14;
                case Mode$1.Alphanumeric:
                    return 13;
                case Mode$1.Byte:
                    return 16;
                case Mode$1.Kanji:
                    return 12;
                default:
                    throw error;
            }
        }
        else {
            throw new Error("illegal version: " + version);
        }
    };
    return QRData;
}());

export { QRData };
